import ActiveCrypt from '@/crypt.active';

class searchController{
  /**
   *
   * @param $state
   * @param $stateParams
   */
  constructor(
    $state,
    $stateParams
  ){
    'ngInject';

    this.ActiveCrypt = new ActiveCrypt();

    this.$state     = $state;

    this.stateName  = this.$state.current.name;
    this.input      = $stateParams.search ? this.ActiveCrypt.decrypt($stateParams.search).input : null;

  }

  $onChange(){
    let params = this.input.length ? { 'search': this.ActiveCrypt.encrypt({
      fields  : this.fields,
      input   : this.input
    }) } : {};
    this.$state.go( this.stateName, params );
  }

}

export default searchController;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/search/search.controller.js
 **/